module.exports = __webpack_public_path__ + "img/iMac.eda2c024.png";